import { Route } from 'react-router';
import { getSetPasswordLinkExpiredPath } from '../InviteUserFlow/SetPasswordLinkExpiredPage/path/path';
import { SetPasswordLinkExpiredPage } from '../InviteUserFlow/SetPasswordLinkExpiredPage/SetPasswordLinkExpiredPage';
import { getLinkExpiredPath } from '../pages/LinkExpiredPage/path/path';
import { LinkExpiredPage } from '../pages/LinkExpiredPage/LinkExpiredPage';
import { amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { INVITE_USER_FLOW_ROUTES } from '../InviteUserFlow/routes';
import { LOGIN_FLOW_ROUTES } from '../LoginFlow/routes';
import { FORGOT_PASSWORD_FLOW_ROUTES } from '../ForgotPasswordFlow/routes';
import { ADMIN_ONBOARDING_FLOW_ROUTES } from '../AdminOnboardingFlow/routes';
import { PasswordChangedPage } from '../pages/PasswordChangedPage/PasswordChangedPage';
import { getPasswordChangedPath } from '../pages/PasswordChangedPage/path/path';

export const AuthRoutes = [
  ...LOGIN_FLOW_ROUTES,
  ...INVITE_USER_FLOW_ROUTES,
  ...FORGOT_PASSWORD_FLOW_ROUTES,
  ...ADMIN_ONBOARDING_FLOW_ROUTES,

  // Informational pages routes
  <Route
    key={getPasswordChangedPath()}
    path={getPasswordChangedPath()}
    element={
      <PasswordChangedPage onRedirect={() => amplitudeService.logEvent(AMPLITUDE_EVENTS.SetPasswordRedirectSignIn)} />
    }
  />,
  <Route
    key={getSetPasswordLinkExpiredPath()}
    path={getSetPasswordLinkExpiredPath()}
    element={<SetPasswordLinkExpiredPage />}
  />,
  <Route key={getLinkExpiredPath()} path={getLinkExpiredPath()} element={<LinkExpiredPage />} />,
  // End of Informational pages routes
];
